import React, { useState, useEffect } from "react"

import { Container, CardBody, Card } from "reactstrap"
import Breadcrumb from "components/Common/Breadcrumb"

import moment from "moment"
import { axiosbaseurl } from "configure"
import Loader from "components/Common/Loader"
import InvoicesList from "./InvoicesList"
import PermittedComponent from "components/Common/PermittedComponent"
import { usePermissionData } from "AppContext"

const Invoices = () => {

    const [table_data, settable_data] = useState([])
    const [loading, setLoading] = useState(false)

    const { checkAccess } = usePermissionData()
    const module_id = 23;

    const queryParams = new URLSearchParams(window.location.search);
    // Extract the 'name' query parameter
    const invoiceType = queryParams.get('search');

    document.title = "Invoices | Peacock Accountants Limited";

    useEffect(() => {
        const getInvoices = async () => {
            try {
                setLoading(true)
                const response = await axiosbaseurl.get("/xero/invoices");
                if (response.data.success) {

                    let transformedData = response.data.data?.map(item => ({
                        invoiceID: item.invoiceID,
                        type: item.type,
                        clientName: item.contact?.name,
                        invoiceNumber: item.invoiceNumber,
                        currencyCode: item.currencyCode,
                        date: moment(item.date).format("DD MMMM, YYYY"),
                        dueDate: moment(item.dueDate).format("DD MMMM, YYYY"),
                        subTotal: item.subTotal,
                        totalTax: item.totalTax,
                        total: item.total,
                        isDiscounted: item.isDiscounted,
                        status: item.status,
                        amountDue: item.amountDue,
                        amountPaid: item.amountPaid,
                        amountCredited: item.amountCredited,
                    }))

                    if (invoiceType)
                        transformedData = transformedData.filter(i => i.status === invoiceType)

                    settable_data(transformedData)
                }
            } catch (error) {
                console.log(error)
            } finally {
                setLoading(false)
            }
        }
        getInvoices()
    }, [])

    return (
        <>
            {loading && <Loader />}
            <div className="page-content mb-5">
                <Container fluid >
                    <Breadcrumb
                        title={"Dashboard"}
                        breadcrumbItem={"Invoices"}
                    />

                    <Card className="px-0 mx-0">
                        <CardBody >
                            <PermittedComponent isAccess={checkAccess(module_id, "view")}>
                                <InvoicesList table_data={table_data} />
                            </PermittedComponent>
                        </CardBody>
                    </Card>

                </Container>
            </div>
        </>
    )
}



export default Invoices
